import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=8f0eb7c8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=8f0eb7c8&prod&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=8f0eb7c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0eb7c8",
  null
  
)

export default component.exports